import {
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { SendSiteCommands } from "../../api/api";

type MoveDGMemberResult = {
  status: string;
  Msg?: string;
  errorCode?: string;
};

type sitecommandsInput = {
  serials: string[];
  commands: Object;
  filter: Object;
  siteName: string;
  fvTuning?: boolean;
};

export const useSiteCommands = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      serials,
      siteName,
      filter,
      commands,
      fvTuning,
      token,
    }: sitecommandsInput & {
      token: string;
    }): Promise<MoveDGMemberResult> =>
      SendSiteCommands(token, {
        serials,
        siteName,
        filter,
        commands,
        fvTuning,
      }),

    onSuccess: (data) => {
      console.log("data", data);
    },

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      {
        serials,
        siteName,
        filter,
        commands,
        fvTuning,
      }: sitecommandsInput,
      options?: {
        onSuccess?: (data: MoveDGMemberResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      const finalCommands = [commands];
      mutation.mutateAsync(
        {
          serials,
          siteName,
          filter,
          commands: finalCommands,
          fvTuning,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return {
    ...mutation,
    mutate: mutateWithToken,
  };
};
